import { IcContactMultiPickerProps, IcContactPicker } from '@sgme/ui';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import type { IntlKey } from 'locales';
import { useIntl } from 'react-intl';

type Props = Omit<IcContactMultiPickerProps, 'type'> & {
  placeholderTranslationKey?: IntlKey;
} & ({ withLabel: true; labelTranslationKey: IntlKey } | { withLabel: false });

export function IcMultiplePicker({ placeholderTranslationKey, ...props }: Props) {
  const isDarkMode = useSgBsTheme() === 'dark';
  const { formatMessage } = useIntl();

  return (
    <>
      {props.withLabel === true && (
        <p className="fs-6 pt-1 pb-2">
          {formatMessage({
            id: props.labelTranslationKey,
          })}
        </p>
      )}
      <IcContactPicker
        {...props}
        className="w-100"
        type="multi"
        size="lg"
        placeholder={
          props.placeholder ??
          formatMessage({
            id: placeholderTranslationKey,
          })
        }
        outline
        theme={isDarkMode ? 'dark' : 'standard'}
        scope="extendedInternal"
      />
    </>
  );
}

IcMultiplePicker.displayName = 'IcMultiplePicker';
